"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeIdFromName = exports.fieldPropTypes = void 0;
exports.makeIdString = makeIdString;
exports.wrapIfHorizontal = exports.textfieldPropTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldsize = require("./fieldsize");
var _fieldModule = _interopRequireDefault(require("./field.module.scss"));
// Common field attributes
// =======================

const fieldPropTypes = exports.fieldPropTypes = {
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  type: _propTypes.default.string,
  ..._fieldsize.fieldSizePropTypes,
  errorMessage: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  subLabel: _propTypes.default.string,
  classNames: _propTypes.default.object,
  label: _propTypes.default.node,
  id: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  tooltip: _propTypes.default.node,
  isHorizontal: _propTypes.default.bool,
  innerRef: _propTypes.default.oneOfType([_propTypes.default.func,
  // 'any' instead of instanceOf(Element) to support SSR out of the box
  _propTypes.default.shape({
    current: _propTypes.default.any
  })])
};
const textfieldPropTypes = exports.textfieldPropTypes = {
  ...fieldPropTypes,
  maxLength: _propTypes.default.number,
  pattern: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  autoCorrect: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  showCharacterCount: _propTypes.default.bool,
  suggestedLength: _propTypes.default.number,
  step: _propTypes.default.number,
  inputMode: _propTypes.default.string
};
function makeIdString() {
  return Math.random().toString(36).slice(2);
}
const makeIdFromName = name => name.replace(/[^A-Za-z0-9]/g, '-');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.makeIdFromName = makeIdFromName;
const wrapIfHorizontal = (opts, children) => opts.isHorizontal ? /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)(_fieldModule.default[`horizontal${opts.type}Wrapper`], opts.classNames[`horizontal${opts.type}Wrapper`])
}, children) : children;
exports.wrapIfHorizontal = wrapIfHorizontal;